export default "__VITE_ASSET__ZAszS7jb__"